import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../shared/shared.module'
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';
import { AgGridModule } from 'ag-grid-angular';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { AuditorRegistrationComponent } from './auditor/auditor-registration/auditor-registration.component';
import { ComplainceAdminRoutingModule } from '../../complainceAdmin-routing.module';
import { AcarTorSetupComponent } from './admin/acar-tor-setup/acar-tor-setup.component';
import { AcarTorBuildingComponent } from './admin/acar-tor-building/acar-tor-building.component';
import { AcarEditTorHeaderComponent } from './admin/acar-edit-tor-header/acar-edit-tor-header.component';
import { AcarTorBuilderComponent } from './admin/acar-tor-builder/acar-tor-builder.component';
import { AcarTorPreviewComponent } from './admin/acar-tor-preview/acar-tor-preview.component';
import { AcarAuditComponent } from './auditor/acar-audit/acar-audit.component';
import { AcarAdminReportComponent } from './admin/acar-admin-report/acar-admin-report.component';
import { AcarAdminApproveRejectComponent } from './admin/acar-admin-approve-reject/acar-admin-approve-reject.component';
import { AcarAuditReportComponent } from './auditor/acar-audit-report/acar-audit-report.component';
import { AcarEligibleMemberComponent } from './member/acar-eligible-member/acar-eligible-member.component';
import { AcarAddMemberComponent } from './member/acar-add-member/acar-add-member.component';

@NgModule({
  declarations: [
    AuditorRegistrationComponent,
    AcarTorSetupComponent,
    AcarTorBuildingComponent,
    AcarEditTorHeaderComponent,
    AcarTorBuilderComponent,
    AcarTorPreviewComponent,
    AcarAuditComponent,
    AcarAuditReportComponent,
    AcarAdminReportComponent,
    AcarAdminApproveRejectComponent,
    AcarEligibleMemberComponent,
    AcarAddMemberComponent,
    
  ],
  imports: [
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule,
    ComplainceAdminRoutingModule
  ]
})
export class AnnualComplianceAuditReportModule { }
